import { ALL_TYPES } from "./types";

export function setToken(data) {
  localStorage.setItem("token", data);
  return {
    type: ALL_TYPES.TOKEN,
    data: data,
  };
}

export function setInfo(data) {
  localStorage.setItem("info", data);
  return {
    type: ALL_TYPES.INFO,
    data: data,
  };
}

export function setArrayTests(data) {
  return {
    type: ALL_TYPES.ARRAY_TESTS,
    data: data,
  };
}

export function setStatuses(data) {
  return {
    type: ALL_TYPES.STATUSES,
    data: data,
  };
}

export function setUser(data) {
  return {
    type: ALL_TYPES.USER,
    data: data,
  };
}

export function setUsers(data) {
  return {
    type: ALL_TYPES.USERS,
    data: data,
  };
}
